import { t } from "../../utils/i18n";
import { HelpIcon } from "./icons";
import { Tooltip } from "./Tooltip";

type HelpButtonProps = {
  title?: string;
  name?: string;
  id?: string;
  onClick?(): void;
};

export const HelpButton = (props: HelpButtonProps) => (
  <Tooltip label={t("buttons.help")}>
    <button
      className="help-icon"
      onClick={props.onClick}
      type="button"
      aria-label={props.title}
    >
      {HelpIcon}
    </button>
  </Tooltip>

);
